import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faUsers } from '@fortawesome/free-solid-svg-icons'

import * as Strings from './strings'
import * as Styles from './styles'

export const mainListItems = (
  <div>
    <ListItem button onClick={() => {}}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faUsers} color={'#3B424D'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p>{Strings.default.CUSTOMERS}</p>
      </ListItemText>
    </ListItem>
  </div>
)

export const SecondaryListItems = props => (
  <div>
    <ListItem button onClick={() => props.onSignOut()}>
      <div style={Styles.default.iconContainer}>
        <FontAwesomeIcon icon={faSignOutAlt} color={'#e57373'} />
      </div>
      <ListItemText style={{ position: 'absolute', left: 75 }}>
        <p style={{ color: '#e57373' }}>{Strings.default.SIGN_OUT}</p>
      </ListItemText>
    </ListItem>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/common/ListItems/index.js